module.exports = __webpack_public_path__ + "img/vertical_4_1_5012.2c408d2b.png";